import { push } from 'connected-react-router';
import { META } from '../../../constants/config';

import {
  optionsFetchRequest,
  optionsFetchRequestSuccess,
  optionsFetchRequestFailure,
} from './actions';
import { fetch, store } from '../../../utils/httpUtil';
import { getLocalStorage, setLocalStorage } from '../../../utils/storageUtil';

export const fetchOptionList = (optionType, optionName, parentCode = undefined) => {
  return (dispatch) => {
    dispatch(optionsFetchRequest());
    return store(`public/public-endpoints/api/lookup`, { optionType, parentCode })
      .then((response) => {
        if (response?.data?.message === 'SUCCESS') {
          const metaData = getLocalStorage(META) || [];
          if (!metaData.some((obj) => obj?.category === optionName)) {
            const detailData = response?.data?.data?.list?.map((obj) => {
              obj.category = optionName;
              return obj;
            });
            const finalMetaData = [...metaData, ...detailData];
            setLocalStorage(META, finalMetaData);
          }
          dispatch(optionsFetchRequestSuccess(response?.data?.data?.list, optionName));
        } else {
          // TODO
        }
      })
      .catch((error) => dispatch(optionsFetchRequestFailure(error?.response?.data)));
  };
};
